import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-multistep-process-details-view',
    templateUrl: './multistep-process-details-view.component.html',
    styleUrls: ['./multistep-process-details-view.component.scss']
})
export class MultistepProcessDetailsViewComponent implements OnInit {
    constructor(@Inject(MAT_DIALOG_DATA) public data: ITaskModel) {}

    public job: ITaskModel;

    ngOnInit() {
        this.job = this.data;
    }
}
